export default function cn(...classNames: Array<string | undefined>) {
    return classNames.filter((e) => e).join(" ");
}
